import type { FavoritesList, FavoritesListItem } from 'interfaces/Account';
import type { Tag } from 'interfaces/Taxonomy';
import type { PrimaryPostDetails } from 'interfaces/content/articles/Post';

export const formatAmpersand = (name: string) => (name !== 'Uncategorized' ? name.replace(/&amp;/g, '&') : '');

export const getFollowablePostTopics = (postTopics: Tag[] | null, favoritesTopics: FavoritesList) => {
  if (!postTopics) return [];
  const followableTopics = favoritesTopics.filter(
    (favoriteTopic: FavoritesListItem) => !!postTopics.find((postTopic: Tag) => postTopic.name === favoriteTopic.name),
  );
  return followableTopics;
};

export const getFollowablePrimaryTopic = (
  defaultPrimaryTopic: PrimaryPostDetails | FavoritesListItem,
  followablePostTopics: FavoritesList,
): string => {
  const isDefaultPrimaryTopicFollowable = !!followablePostTopics.find(
    (followablePostTopic: FavoritesListItem) => followablePostTopic.name === defaultPrimaryTopic.name,
  );

  if (!isDefaultPrimaryTopicFollowable) {
    // eslint-disable-next-line no-param-reassign
    [defaultPrimaryTopic] = followablePostTopics;
  }

  return defaultPrimaryTopic.name;
};
